__turbopack_context__.v({
  "about": "PortalSurface-module__EqgOXa__about",
  "account": "PortalSurface-module__EqgOXa__account",
  "accountButton": "PortalSurface-module__EqgOXa__accountButton",
  "accountMenu": "PortalSurface-module__EqgOXa__accountMenu",
  "accountName": "PortalSurface-module__EqgOXa__accountName",
  "avatar": "PortalSurface-module__EqgOXa__avatar",
  "badge": "PortalSurface-module__EqgOXa__badge",
  "bookingToolbar": "PortalSurface-module__EqgOXa__bookingToolbar",
  "catalog": "PortalSurface-module__EqgOXa__catalog",
  "catalogHeading": "PortalSurface-module__EqgOXa__catalogHeading",
  "catalogSection": "PortalSurface-module__EqgOXa__catalogSection",
  "contact": "PortalSurface-module__EqgOXa__contact",
  "directoryBackLink": "PortalSurface-module__EqgOXa__directoryBackLink",
  "employeeCard": "PortalSurface-module__EqgOXa__employeeCard",
  "employeeGrid": "PortalSurface-module__EqgOXa__employeeGrid",
  "empty": "PortalSurface-module__EqgOXa__empty",
  "facilitiesSection": "PortalSurface-module__EqgOXa__facilitiesSection",
  "footer": "PortalSurface-module__EqgOXa__footer",
  "gateMain": "PortalSurface-module__EqgOXa__gateMain",
  "gateNotice": "PortalSurface-module__EqgOXa__gateNotice",
  "home": "PortalSurface-module__EqgOXa__home",
  "loginIcon": "PortalSurface-module__EqgOXa__loginIcon",
  "loginLabel": "PortalSurface-module__EqgOXa__loginLabel",
  "loginLink": "PortalSurface-module__EqgOXa__loginLink",
  "main": "PortalSurface-module__EqgOXa__main",
  "multiline": "PortalSurface-module__EqgOXa__multiline",
  "page": "PortalSurface-module__EqgOXa__page",
  "pageHeading": "PortalSurface-module__EqgOXa__pageHeading",
  "portal-content-in": "PortalSurface-module__EqgOXa__portal-content-in",
  "resourceAction": "PortalSurface-module__EqgOXa__resourceAction",
  "resourceCard": "PortalSurface-module__EqgOXa__resourceCard",
  "resourceCopy": "PortalSurface-module__EqgOXa__resourceCopy",
  "resourceGrid": "PortalSurface-module__EqgOXa__resourceGrid",
  "resourceImage": "PortalSurface-module__EqgOXa__resourceImage",
  "resourcePlaceholder": "PortalSurface-module__EqgOXa__resourcePlaceholder",
  "resourceProfile": "PortalSurface-module__EqgOXa__resourceProfile",
  "searchResults": "PortalSurface-module__EqgOXa__searchResults",
  "section": "PortalSurface-module__EqgOXa__section" + " " + __turbopack_context__.i("[project]/apps/client-portal/src/components/PortalDivider.module.css [app-client] (css module)")["band"],
  "sectionContent": "PortalSurface-module__EqgOXa__sectionContent",
  "sectionHeading": "PortalSurface-module__EqgOXa__sectionHeading",
  "sectionSearchStatus": "PortalSurface-module__EqgOXa__sectionSearchStatus",
  "serviceCard": "PortalSurface-module__EqgOXa__serviceCard",
  "serviceCopy": "PortalSurface-module__EqgOXa__serviceCopy",
  "serviceDuration": "PortalSurface-module__EqgOXa__serviceDuration",
  "serviceFooter": "PortalSurface-module__EqgOXa__serviceFooter",
  "serviceGrid": "PortalSurface-module__EqgOXa__serviceGrid",
  "servicePrice": "PortalSurface-module__EqgOXa__servicePrice",
  "skipLink": "PortalSurface-module__EqgOXa__skipLink",
  "teamSection": "PortalSurface-module__EqgOXa__teamSection",
  "textLink": "PortalSurface-module__EqgOXa__textLink",
  "unavailable": "PortalSurface-module__EqgOXa__unavailable",
  "upcomingSection": "PortalSurface-module__EqgOXa__upcomingSection",
  "welcomeFooter": "PortalSurface-module__EqgOXa__welcomeFooter",
});
